import { Role } from "../../types/role";

const ENGun: Role = {
  primary: [
    "Ballannahme",
    "Passen",
    "Technik",
    "Entscheidungen",
    "Nervenstaerke",
    "Uebersicht",
  ],
  secondary: ["Antizipation", "Flair", "OhneBall", "Balance"],
  physis: "mittelfeld",
};

export const ENG = {
  ENGun,
};
